import React from 'react';

import { IconProps } from './type';

const ResetIcon: React.FC<IconProps> = ({ className = '', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2145 19.9005C15.212 19.5647 17.6142 17.1686 17.956 14.1712C18.4047 10.2519 15.3585 6.91569 11.54 6.87295V5.11479C11.54 5.01711 11.4179 4.96522 11.3354 5.02627L7.71533 7.68489C7.65428 7.73067 7.65428 7.81919 7.71533 7.86498L11.3354 10.5236C11.4179 10.5846 11.54 10.5297 11.54 10.4351V8.67996C14.223 8.72269 16.3719 11.0059 16.1887 13.7347C16.0331 16.082 14.1192 17.9867 11.7719 18.1362C9.28425 18.2949 7.16895 16.5185 6.79046 14.1681C6.72025 13.7316 6.33871 13.4142 5.89916 13.4142C5.35279 13.4142 4.92546 13.8995 5.01092 14.4398C5.54204 17.7882 8.63409 20.3004 12.2145 19.9005Z"
      fill="#8A8A8A"
    />
  </svg>
);

export default ResetIcon;
